module.exports = "/_next/static/images/CollectDataDetails@2x-df9e05a47614e8af85376bfb0d9ea394.webp";